import { v2Api } from './v2Client';

const post = (url, body) => v2Api.post(url, body ?? {}).then((r) => r.data);

/**
 * Ligue (MySquash, docs/LEAGUE.md côté API) : le club demande l'affiliation (licence) de ses membres pour la saison
 * courante, la Ligue valide ou refuse dans MySquash. Routes `League/club/*` : staff du club courant. Refus : statut
 * HTTP + `{ error, message }` (409 `already_affiliated`, `affiliations_closed`, `no_current_season`).
 */

export const LEAGUE_LICENCE_TYPE_OPTIONS = [
  { value: 'competition', label: 'Compétition' },
  { value: 'recreative', label: 'Récréative' },
  { value: 'youth', label: 'Jeune' },
  { value: 'other', label: 'Autre' },
];

export const LEAGUE_AFFILIATION_STATUS_LABELS = {
  requested: 'Demandée',
  validated: 'Validée',
  refused: 'Refusée',
  cancelled: 'Annulée',
};

/** Message d'un refus de l'API (le `message` lisible renvoyé avec le code), sinon `fallback`. */
export function leagueErrorMessage(err, fallback = 'Erreur') {
  return err?.response?.data?.message || err?.message || fallback;
}

export const leagueService = {
  /** `{ season_id?, status?, q? }` → { seasons[] (courante d'abord), affiliations[] (du club, demandes en attente d'abord) } */
  clubAffiliations: (params = {}) => post('/League/club/affiliations', params),
  /** `{ player_id, licence_type?, notes? }` : saison courante, si ses affiliations sont ouvertes. */
  requestAffiliation: (body) => post('/League/club/affiliation_request', body),
  /** Annule une demande pas encore traitée par la Ligue. */
  cancelAffiliation: (id) => post('/League/club/affiliation_cancel', { id }),
};
